import React from 'react';
import Col from '@tcp/core/src/components/common/atoms/Col';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Grid from '@tcp/core/src/components/common/molecules/Grid';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import LoaderSkelton from '@tcp/core/src/components/common/molecules/LoaderSkelton';
import { getBrandInCaps, getCountryName } from '@tcp/core/src/utils';
import { SHOW_REFER_FRIEND } from '@tcp/core/src/constants/brandSpecific.constants';
import { SHOW_SMS_SIGN_UP } from '@tcp/core/src/constants/brandCountry.constants';

import style, { FooterSkeletonCandidateA, FooterSkeletonBottomView } from '../Footer.style';

const FooterSkeleton = (props) => {
  const { isPreCheckoutFlow, className, isFooterRedesignEnabled } = props;
  const brandInCaps = getBrandInCaps();
  const countryName = getCountryName();
  const showSmsSignup = SHOW_SMS_SIGN_UP[brandInCaps][countryName];
  return (
    <div className={className}>
      {!isFooterRedesignEnabled && (
        <div className={`content-wrapper`}>
          <FooterSkeletonCandidateA>
            {!isPreCheckoutFlow && (
              <div className="footer-candidate-wrapper footer-skeleton">
                <Grid className="footer_top_candidate_a content-wrapper footer-skeleton">
                  <Row className="footer-skeleton">
                    <Col
                      className={`col-md-half-width footer-item footer-login`}
                      colSize={{
                        large: 4,
                        medium: 4,
                        small: 6,
                      }}
                      ignoreGutter={{
                        small: true,
                      }}
                    >
                      <LoaderSkelton className="loading-item" />
                      <div>
                        <div className="divider hide-in-medium-up" />
                      </div>
                    </Col>
                    {showSmsSignup && (
                      <Col
                        className={`col-md-half-width  footer-item footer-text-alert`}
                        colSize={{
                          large: 4,
                          medium: 4,
                          small: 6,
                        }}
                        ignoreGutter={{
                          small: true,
                        }}
                      >
                        <LoaderSkelton />
                      </Col>
                    )}

                    <div className="divider hide-in-large-up" />

                    <Col
                      className="refer_a_friend_desktop col-md-half-width footer-item-refer"
                      colSize={{
                        large: 4,
                        medium: 12,
                        small: 12,
                      }}
                      ignoreGutter={{
                        small: true,
                        medium: true,
                      }}
                    >
                      {SHOW_REFER_FRIEND[brandInCaps] && <LoaderSkelton />}
                    </Col>

                    <div className="divider hide-in-medium-up" />

                    <Col
                      className={`col-md-half-width  footer-item-download hide-in-medium-up`}
                      colSize={{
                        large: 0,
                        medium: 0,
                        small: 12,
                      }}
                      ignoreGutter={{
                        small: true,
                      }}
                    >
                      <LoaderSkelton />
                    </Col>
                  </Row>
                </Grid>
              </div>
            )}
          </FooterSkeletonCandidateA>
          <FooterSkeletonBottomView>
            <div className="skeleton-middle-section">
              <LoaderSkelton />
            </div>
            <div className="skeleton-copyright">
              <LoaderSkelton />
            </div>
          </FooterSkeletonBottomView>
        </div>
      )}

      {isFooterRedesignEnabled && (
        <div className={`content-wrapper`}>
          <FooterSkeletonBottomView>
            <div className="new-skeleton-middle-section">
              <LoaderSkelton />
            </div>
          </FooterSkeletonBottomView>
        </div>
      )}
    </div>
  );
};

export default withStyles(FooterSkeleton, style);
